export default {
      id: "ic_social_share_link-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_social_share_link-usage",
      toString: function () {
        return this.url;
      }
    }